export default __webpack_public_path__ + "5ba3a5d125875aef684a4d40a61f17d5.ttf";